import { createFileRoute } from '@tanstack/react-router';
import { FC, useEffect } from 'react';
import { useGetChatCredentials } from '@/hooks/chat/useGetChatCredentials';
import { AuthProgressLoader } from '@/components/auth/auth-progress-loader';
import { AuthenticatedChat } from '@/components/custom-chat/authenticated-chat';
import { useChatContext } from 'stream-chat-react';
import { ArchivedChat } from '@/components/custom-chat/archived-chat';

const Chat: FC = () => {
  const { setActiveChannel, client: chatClient, channel } = useChatContext();
  const { data: chatCredentials } = useGetChatCredentials();

  useEffect(() => {
    if (!chatCredentials || !chatCredentials.channelId || !chatClient) return;

    const channel = chatClient.channel('messaging', chatCredentials.channelId);

    channel.watch().then(() => {
      setActiveChannel(channel);
    });
  }, [chatCredentials, chatClient]);

  if (chatCredentials && chatCredentials.isChatNoLongerAccessibleDueToArchival)
    return <ArchivedChat />;

  if (!channel) return <AuthProgressLoader />;

  return <AuthenticatedChat />;
};

export const Route = createFileRoute('/auth/chat')({
  component: Chat,
});
